


















import { defineComponent, ref } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { useBecomeCreatorState } from "@/hooks/useBecomeCreatorState";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationLimitedCreatorApplicationDeclined",
  components: { BaseIcon, BaseButton, NotificationItemView },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup(_, { root }) {
    const { update } = useBecomeCreatorState();

    const loading = ref(false);

    const onClick = async () => {
      try {
        loading.value = true;
        await update(0);
        root.$router.push({ name: "becomeCreator" });
      } finally {
        loading.value = false;
      }
    };

    return {
      loading,
      onClick,
    };
  },
});
